import React from 'react';
import { CalendarXIcon, ShuffleIcon, SearchXIcon, TimerResetIcon } from 'lucide-react';
import { PROBLEMS, type Problem } from '../data/content';
const ICONS: Record<Problem['icon'], React.ElementType> = {
  calendar: CalendarXIcon,
  shuffle: ShuffleIcon,
  search: SearchXIcon,
  timer: TimerResetIcon
};
export function Problems() {
  return <section className="bg-ink py-10 sm:py-12" aria-labelledby="problems-title" data-id="element-134" data-mp="2y1cxvp0m2zoe">
      <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-8" data-id="element-135" data-mp="2t5xjmvyoz1rg">
        <div className="text-center" data-id="element-136" data-mp="2o503eox8shsl">
          <h2 id="problems-title" className="font-display text-[26px] font-bold uppercase leading-[1.02] tracking-tight text-cream sm:text-[34px] lg:text-[40px]" data-id="element-137" data-mp="2o3ylc0ht6v1d">
            Do You Recognize This?
          </h2>
          <div className="hairline-gold mx-auto mt-3 h-px w-20" aria-hidden="true" data-id="element-138" data-mp="hfbs5z46uhj2" />
          <p className="mx-auto mt-3 max-w-xl text-[13.5px] leading-snug text-cream sm:text-[15px]" data-id="element-139" data-mp="ddhve1x45xo6">
            You love coaching. But does programming steal your energy before you
            even step into the gym?
          </p>
        </div>

        <ul className="mt-6 grid grid-cols-2 gap-3 lg:grid-cols-4 lg:gap-4" data-id="element-140" data-mp="39rj1hr5rm9o7">
          {PROBLEMS.map(problem => {
          const Icon = ICONS[problem.icon];
          return <li key={problem.number} className="flex h-full flex-col rounded-lg border border-line bg-panel p-3.5 sm:p-5" data-id="element-141" data-mp="2zstks1pluv9j">
                <div className="flex items-center gap-2" data-id="element-142" data-mp="3sgz3yk10gc79">
                  <Icon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-143" data-mp="3sijxc6bl9p3j" />
                  <span className="font-display text-[11px] font-semibold tracking-[0.2em] text-gold/60" data-id="element-144" data-mp="3eoj5zxmyv4d7">
                    {problem.number}
                  </span>
                </div>
                <h3 className="mt-2 font-display text-[15px] font-bold uppercase leading-[1.1] tracking-wide text-cream sm:text-lg" data-id="element-145" data-mp="aa19n8sqplwy">
                  {problem.title}
                </h3>
                <p className="mt-1.5 text-[12px] leading-snug text-mutedtext sm:text-[13.5px]" data-id="element-146" data-mp="owi4u74xq23r">
                  {problem.body}
                </p>
              </li>;
        })}
        </ul>

        <div className="mt-6 rounded-lg border border-gold/25 bg-charcoal px-4 py-5 text-center" data-id="element-147" data-mp="fvjy3h343ghh">
          <p className="text-[13px] leading-snug text-mutedtext sm:text-[15px]" data-id="element-148" data-mp="awyvxc4aumqe">
            The problem isn’t that you need more random exercises.
          </p>
          <p className="mt-1 font-display text-[30px] font-bold uppercase leading-none tracking-tight text-cream sm:text-4xl" data-id="element-149" data-mp="1877vf2d0mkr">
            You need a <span className="text-gold" data-id="element-150" data-mp="3tcjag2megvca">system</span>.
          </p>
        </div>
      </div>
    </section>;
}